/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { CreateManualQAResult } from './CreateManualQAResult.js';
import {
    CreateManualQAResultFromJSON,
    CreateManualQAResultFromJSONTyped,
    CreateManualQAResultToJSON,
} from './CreateManualQAResult.js';

/**
 * 
 * @export
 * @interface CreateManualQARequest
 */
export interface CreateManualQARequest {
    /**
     * 
     * @type {CreateManualQAResult}
     * @memberof CreateManualQARequest
     */
    result?: CreateManualQAResult;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateManualQARequest
     */
    hiddenLedgerItems?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateManualQARequest
     */
    shownLedgerItems?: Array<string>;
}

/**
 * Check if a given object implements the CreateManualQARequest interface.
 */
export function instanceOfCreateManualQARequest(value: object): boolean {
    return true;
}

export function CreateManualQARequestFromJSON(json: any): CreateManualQARequest {
    return CreateManualQARequestFromJSONTyped(json, false);
}

export function CreateManualQARequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateManualQARequest {
    if (json == null) {
        return json;
    }
    return {
        
        'result': json['result'] == null ? undefined : CreateManualQAResultFromJSON(json['result']),
        'hiddenLedgerItems': json['hiddenLedgerItems'] == null ? undefined : json['hiddenLedgerItems'],
        'shownLedgerItems': json['shownLedgerItems'] == null ? undefined : json['shownLedgerItems'],
    };
}

export function CreateManualQARequestToJSON(value?: CreateManualQARequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'result': CreateManualQAResultToJSON(value['result']),
        'hiddenLedgerItems': value['hiddenLedgerItems'],
        'shownLedgerItems': value['shownLedgerItems'],
    };
}

